<template>
  <!-- 焦点 -->
  <div id="Focus">
    <Header></Header>
    <Navigate></Navigate>
    <div class="content">
      <div class="crumbs">
        <i class="iconfont icon-zhuye"></i>
        <span><router-link :to="{name:'home'}">首页</router-link></span>
        <i class="iconfont icon-youjiantou"></i>
        <span><a>焦点</a></span>
      </div>
      <div class="content_body">
        <div class="content_body_left">
          <BannerLeft></BannerLeft>
        </div>
        <div class="content_body_right">
          <router-view></router-view>
        </div>
      </div>
      <div style="clear:both"></div>
    </div>
    <Foot></Foot>
  </div>
</template>

<script>
import Header from '@/components/public/heade/index'
import Navigate from '@/components/public/navigation/index'
import Foot from '@/components/public/foot/index'
import BannerLeft from '@/components/public/bannerLeft/index'

export default {
  name:'Focus',
  data(){
    return{
      
    }
  },
  components:{
    Header,
    Navigate,
    Foot,
    BannerLeft
  }
}
</script>

<style lang="less" scoped>
  #Focus{
    .content{
      width:1200px;
      height:100%;
      margin:0 auto;
      .crumbs{
        width:1200px;
        height:20px;
        position:relative;
        text-align:left;
        margin-top:24px;
        margin-left: 2%;
        line-height:20px;
        span:nth-child(2) a{
          color:#000000;
          font-size:16px;
          font-weight:bold;
          cursor:pointer;
        }
        i{
          color:#767C82;
          font-size:18px;
          margin-left:10px;
          font-weight:bold;
        }
        i:nth-child(1){
          color:#000;
          margin-right:5px;
        }
        span:nth-child(4) a{
          color:#C01B22;
          font-size:16px;
          margin-left:10px;
          font-weight:bold;
          cursor:pointer;
        }
      }
      .content_body{
       width: 1130px;
    height: 100%;
    margin-left: 3%;
    margin-top: 20px;
    border: 1px solid #bbbbbb;
        padding-left: 30px;
    padding-right: 30px;
        .content_body_left{
          width:280px;
          height:100%;
          border-right:1px solid #EEEEEE;
          float:left;
          .content_body_left_divA{
            width:266px;
            height:192px;
            border:1px solid #C01B22;
            position:relative;
            .content_body_left_divA_head{
              width:              100%;
height:46px;
              background:#C01B22;
              top:0;
              margin:0 auto;
              padding:0 5px;
              line-height:46px;
              i{
                font-size:22px;
                color:#fff;
              }
              i:nth-child(1){
                margin-right:15px;
              }
              i:nth-child(3){
                float:right;
                position:relative;
                top:3px;
              }
              span{
                color:#fff;
                font-size:20px;
              }
            }
            .content_body_left_divA_cont{
              width:77%;
              margin:0 auto;
              margin-top:10px;
              li{
                width:70%;
                list-style:none;
                padding:9px 0;
                a{
                  color:#000;
                  font-size:16px;
                  float:left;
                }
                i{
                  color:#767C82;
                  font-size:18px;
                  float:right;
                }
                .router-link-active{
                  color:#C01B22;
                }
              }
              li:hover{
                a{color:#C01B22;}
                i{color:#C01B22;}
              }
            }
          }
        }
        .content_body_right{
           width: 1130px;
        height: auto;
        margin-left: 3%;
          // float:right;
          // margin-left:15px;
        }
      }
    }
  }
  /deep/.content_body_left_divC{
		margin-top: 0!important;
	}
</style>



// WEBPACK FOOTER //
// src/components/Focus/index.vue